import { AllTokens } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import { BPM_ROLES_MAIN_PATH } from "./pages/bpm-roles/main";
import { DYNAMIC_PROCESSES_LIST_PATH } from "./dynamic-processes/pages/dynamic-processes-list";
import DynamicProcessesListPage from "./dynamic-processes/pages/dynamic-processes-list/dynamic-processes-list";
import {
  DYNAMIC_PROCESSES_EDITOR_PATH,
  DynamicProcessesEditorPage,
} from "./dynamic-processes/pages/dynamic-processes-editor";
import {
  NOTIFICATION_TEMPLATE_LIST_PATH,
  NotificationTemplateListPage,
} from "./notification-templates/pages/notification-template-list";
import {
  NOTIFICATION_TEMPLATE_EDITOR_PATH,
  NotificationTemplateEditorPage,
} from "./notification-templates/pages/notification-template-editor";

import {
  BPM_PROCESS_EDITOR_PATH,
  BpmProcessEditorPage,
} from "./bpm-process/page/bpm-process-editor";
import BpmRolesMain from "./pages/bpm-roles/main/bpm-roles-main";

import {
  TriggerActionListPage,
  TRIGGER_ACTION_LIST_PATH,
} from "../automation/pages/trigger-action-list";
import { RestrictDynamicProcesses } from "./shared/access/restrict-dynamic-processes";
import { RestrictNotificationTemplates } from "./shared/access/restrict-notification-templates";

export const routes = [
  {
    path: BPM_ROLES_MAIN_PATH,
    element: (
      <Guard.Redirect.IfCantModify.PageNotFound
        influencedBy={[AllTokens.TasksRoles]}
      >
        <BpmRolesMain />
      </Guard.Redirect.IfCantModify.PageNotFound>
    ),
  },

  {
    path: DYNAMIC_PROCESSES_LIST_PATH,
    element: (
      <RestrictDynamicProcesses>
        <DynamicProcessesListPage />
      </RestrictDynamicProcesses>
    ),
  },
  {
    path: DYNAMIC_PROCESSES_EDITOR_PATH,
    element: (
      <RestrictDynamicProcesses>
        <DynamicProcessesEditorPage />
      </RestrictDynamicProcesses>
    ),
  },
  {
    path: NOTIFICATION_TEMPLATE_LIST_PATH,
    element: (
      <RestrictNotificationTemplates>
        <NotificationTemplateListPage />
      </RestrictNotificationTemplates>
    ),
  },
  {
    path: NOTIFICATION_TEMPLATE_EDITOR_PATH,
    element: (
      <RestrictNotificationTemplates>
        <NotificationTemplateEditorPage />
      </RestrictNotificationTemplates>
    ),
  },
  {
    path: BPM_PROCESS_EDITOR_PATH,
    element: (
      <Guard.Redirect.IfCantModify.PageNotFound
        influencedBy={[AllTokens.TasksProcesses]}
      >
        <BpmProcessEditorPage />
      </Guard.Redirect.IfCantModify.PageNotFound>
    ),
  },
  {
    path: TRIGGER_ACTION_LIST_PATH,
    element: <TriggerActionListPage />,
  },
];
